import { isValidEmail } from 'data/string';
import { createTenantSuccessStateName } from 'modules/application/tenant';
import { ORGANIZATION_INVITATION_INVITE_BUTTON, ORGANIZATION_INVITATION_NOT_NOW_BUTTON, ORGANIZATION_INVITATION_NEW_MEMBER_GROUP_BUTTON, ORGANIZATION_INVITATION_EMAIL_INPUT, ORGANIZATION_INVITATION_ROLE_SELECT, ORGANIZATION_INVITATION_DELETE_BUTTON, } from '../TenantSegmentEvents';
import './inviteMember.scss';
export class InviteMemberController {
    static $inject = ['TenantService', '$stateParams', '$translate', 'PORTALDOMAIN', '$state', 'LoadingService', 'BlipToastService', 'SegmentService', 'AlertService'];
    constructor(TenantService, $stateParams, $translate, PORTALDOMAIN, $state, LoadingService, BlipToastService, SegmentService, AlertService) {
        'ngInject';
        this.TenantService = TenantService;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.PORTALDOMAIN = PORTALDOMAIN;
        this.$state = $state;
        this.LoadingService = LoadingService;
        this.BlipToastService = BlipToastService;
        this.SegmentService = SegmentService;
        this.AlertService = AlertService;
        this.memberGroups = [{ emails: [], role: undefined }];
        this.validForm = false;
        this.onChangeEmails = async (event) => {
            const index = event.target.id.split('-')[2];
            const isValidInput = await this.inputEmailElement(index).isValid();
            this.setInputValidity(isValidInput, index);
            this.setFormValidity();
            const { value } = event.detail;
            if (value && !Array.isArray(value)) {
                this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_EMAIL_INPUT, { organizationId: this.organization.id, organizationName: this.organization.name });
                if (isValidEmail(value.trim()) && this.memberGroups[index].emails.indexOf(value) === -1) {
                    this.memberGroups[index].emails.push(value);
                    return;
                }
            }
            else {
                if (!this.inputEmailElement(index).value) {
                    this.memberGroups[index].emails = [];
                }
            }
        };
        this.onBlurEmails = async (event) => {
            const index = event.target.id.split('-')[2];
            await this.convertValueToChip(index);
        };
        this.setInputValidity = (value, index) => {
            this.inputEmailElement(index).danger = !value;
        };
        this.setInputValue = () => {
            for (const [index, memberGroup] of this.memberGroups.entries()) {
                this.inputEmailElement(index).chips = memberGroup.emails;
            }
        };
        this.setFormValidity = async () => {
            let validInput = false;
            for (const [index, memberGroup] of this.memberGroups.entries()) {
                validInput = await this.inputEmailElement(index).isValid();
                if (memberGroup.emails.length === 0 || memberGroup.role === undefined || !validInput) {
                    this.validForm = false;
                    return;
                }
            }
            this.validForm = true;
        };
        this.onChangeRole = () => {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_ROLE_SELECT, { organizationId: this.organization.id, organizationName: this.organization.name });
            this.setFormValidity();
        };
        this.addMemberGroup = () => {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_NEW_MEMBER_GROUP_BUTTON, { organizationId: this.organization.id, organizationName: this.organization.name });
            this.memberGroups.push({ emails: [], role: undefined });
            this.validForm = false;
        };
        this.onClickDeleteMemberGroupButton = (index) => {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_DELETE_BUTTON, { organizationId: this.organization.id, organizationName: this.organization.name });
            if (this.memberGroups[index].emails.length > 0) {
                this.openDeleteMemberGroupAlert(index);
            }
            else {
                this.deleteMemberGroup(index);
            }
        };
        this.openDeleteMemberGroupAlert = async (index) => {
            const deleteMemberGroupAlert = {
                title: this.$translate.instant('inviteMember.deleteMemberGroupAlert.title'),
                body: this.$translate.instant('inviteMember.deleteMemberGroupAlert.body'),
                buttons: {
                    cancel: this.$translate.instant('inviteMember.deleteMemberGroupAlert.back'),
                    confirm: this.$translate.instant('inviteMember.deleteMemberGroupAlert.confirm'),
                },
            };
            await this.AlertService.show({
                title: deleteMemberGroupAlert.title,
                body: deleteMemberGroupAlert.body,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: deleteMemberGroupAlert.buttons.cancel,
                    confirm: deleteMemberGroupAlert.buttons.confirm,
                },
                callback: {
                    cancelButtonAction: () => {
                    },
                    confirmButtonAction: () => this.deleteMemberGroup(index),
                },
            });
        };
        this.deleteMemberGroup = (index) => {
            this.memberGroups.splice(index, 1);
            this.setInputValue();
            this.setFormValidity();
        };
        this.skipStep = () => {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_NOT_NOW_BUTTON, { organizationId: this.organization.id, organizationName: this.organization.name });
            this.$state.go(createTenantSuccessStateName, {
                id: this.organization.id,
                name: this.organization.name,
            });
        };
    }
    async $onInit() {
        this.roleOptions = [
            {
                label: await this.$translate('inviteMember.guest'),
                value: 'guest',
            },
            {
                label: await this.$translate('inviteMember.member'),
                value: 'member',
            },
            {
                label: await this.$translate('inviteMember.admin'),
                value: 'admin',
            },
        ];
        const { tenantId, tenantName } = this.$stateParams;
        this.organization = { id: tenantId, name: tenantName, link: `${tenantId}.${this.PORTALDOMAIN}`.toLowerCase() };
        this.invalidEmailError = await this.$translate('inviteMember.invalidEmail');
    }
    inputEmailElement(index) {
        return document.querySelector('#member-emails-' + index);
    }
    async convertValueToChip(index) {
        if (!this.inputEmailElement(index).value) {
            return;
        }
        await this.inputEmailElement(index).add(this.inputEmailElement(index).value);
        this.inputEmailElement(index).value = '';
    }
    groupByRole() {
        const roles = [];
        let index = 0;
        for (const memberGroup of this.memberGroups) {
            const roleName = memberGroup.role;
            index = roles.map(e => e.role).indexOf(roleName);
            if (index < 0) {
                roles.push({ role: roleName, emails: memberGroup.emails });
            }
            else {
                roles[index].emails = [...new Set([...roles[index].emails, ...memberGroup.emails])];
            }
        }
        return roles;
    }
    async inviteMembers() {
        this.LoadingService.startLoading(false);
        const invites = this.groupByRole();
        const emails = [];
        try {
            for (const invite of invites) {
                await this.TenantService.inviteMany(invite.emails, this.organization.id, invite.role);
                emails.push(...invite.emails);
            }
            const invitesLength = invites.map((invite) => {
                return {
                    usersInvited: invite.emails.length,
                    role: invite.role,
                };
            });
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_INVITE_BUTTON, { ...invitesLength, ...{ organizationId: this.organization.id, organizationName: this.organization.name } });
            this.$state.go(createTenantSuccessStateName, {
                id: this.organization.id,
                name: this.organization.name,
                invitationsSent: true,
            });
        }
        catch (e) {
            console.error(e);
            const msg = await this.$translate('inviteMemberModal.sendingError');
            this.BlipToastService.show('danger', {
                msg,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
}
InviteMemberController.$inject = ['TenantService', '$stateParams', '$translate', 'PORTALDOMAIN', '$state', 'LoadingService', 'BlipToastService', 'SegmentService', 'AlertService'];
